import Loadable from "app/components/Loadable";
import { lazy } from "react";

const AIAssistantTemplateListPage = Loadable(lazy(() => import("./AIAssistantTemplateListPage")));
const AIAssistantTemplateFormPage = Loadable(lazy(() => import("./AIAssistantTemplateFormPage")));

const sysadminAIAssistantTemplateRoutes = [
  { path: "sysadmin/ai-assistant-templates", element: <AIAssistantTemplateListPage /> },
  { path: "sysadmin/ai-assistant-templates/:id", element: <AIAssistantTemplateFormPage /> },
];

export default sysadminAIAssistantTemplateRoutes;
